// extracted by mini-css-extract-plugin
export default {"details":"Footer_details__khnEg","link":"Footer_link__MsGIJ"};